// Stats displayed in the About section (animated counters).
export const stats = [
    { label: "Building Brands Since", value: "2013", numeric: 2013, suffix: "", static: true },
    { label: "High-Value Brands Built", value: 350, numeric: 350, suffix: "+" },
    { label: "Additional Branding Projects", value: 700, numeric: 700, suffix: "+" },
    { label: "Combined Client Revenue", value: 1, numeric: 1, suffix: "B+", prefix: "$" },
];
